export const theme = {
     color: {
        white: 'hsl(0, 0%, 100%)',
        whiteSmoke: 'hsl(0, 0%, 96%)',
        warmGrey: 'hsl(48, 2%, 57%)',
        smoke: 	'hsl(0, 0%, 19%)',
        black: 	'hsl(237, 100%, 4%)',
      //   green: 'hsl(153, 63%, 18%)',
        green: '#23443D',
        sageGreen: 'hsl(89, 58%, 22%)',
     },
     font: {
        size: {
            // 1rem - 16px
            // 72px
            // 36px
            // 22px
            // 18px
            heading: '4rem',
            headingMobile: '2.4rem',
            headingSmall: '4.2rem',
            paragraph: '1.125rem',
            caption: '1.35rem',
            //36px
            mobileMenu: '2.25rem',
            //22px
            desktopMenu: '1.375rem',
        },
        family: {
            montserrat: '"Montserrat", sans-serif',
        },
     },
     mq: {
        tablet: '@media (min-width: 768px)',
        desktop: '@media (min-width: 1024px)',
     }
}